/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as LangRouteRouteImport } from './routes/$lang/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangAuthenticatedRouteImport } from './routes/$lang/_authenticated'
import { Route as LangAuthenticatedWorkstationsRouteRouteImport } from './routes/$lang/_authenticated/workstations/route'
import { Route as LangAuthenticatedTagsRouteRouteImport } from './routes/$lang/_authenticated/tags/route'
import { Route as LangAuthenticatedSelectPartsTrackingRouteRouteImport } from './routes/$lang/_authenticated/select-parts-tracking/route'
import { Route as LangAuthenticatedSelectPartsRouteRouteImport } from './routes/$lang/_authenticated/select-parts/route'
import { Route as LangAuthenticatedReprintTagsTrackingRouteRouteImport } from './routes/$lang/_authenticated/reprint-tags-tracking/route'
import { Route as LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteImport } from './routes/$lang/_authenticated/reprint-tags-manufacturing-orders/route'
import { Route as LangAuthenticatedPrintTagsTrackingRouteRouteImport } from './routes/$lang/_authenticated/print-tags-tracking/route'
import { Route as LangAuthenticatedPrintTagsRouteRouteImport } from './routes/$lang/_authenticated/print-tags/route'
import { Route as LangAuthenticatedMoRouteRouteImport } from './routes/$lang/_authenticated/mo/route'
import { Route as LangAuthenticatedMenuPrintTagsRouteRouteImport } from './routes/$lang/_authenticated/menu-print-tags/route'
import { Route as LangAuthenticatedHelpBoardRouteRouteImport } from './routes/$lang/_authenticated/help-board/route'
import { Route as LangAuthenticatedDashboardTrackingRouteRouteImport } from './routes/$lang/_authenticated/dashboard-tracking/route'
import { Route as LangAuthenticatedDashboardMoRouteRouteImport } from './routes/$lang/_authenticated/dashboard-mo/route'
import { Route as LangAuthenticatedDashboardRouteRouteImport } from './routes/$lang/_authenticated/dashboard/route'
import { Route as LangAuthenticatedChecklistsManualRouteRouteImport } from './routes/$lang/_authenticated/checklists-manual/route'
import { Route as LangAuthenticatedChecklistsRouteRouteImport } from './routes/$lang/_authenticated/checklists/route'
import { Route as LangAuthenticatedTagsViewRouteRouteImport } from './routes/$lang/_authenticated/tags/$view/route'
import { Route as LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteImport } from './routes/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/route'
import { Route as LangAuthenticatedMoOptionRouteRouteImport } from './routes/$lang/_authenticated/mo/$option/route'
import { Route as LangAuthenticatedMenuPrintTagsDefaultRouteRouteImport } from './routes/$lang/_authenticated/menu-print-tags/default/route'
import { Route as LangAuthenticatedMenuPrintTagsBafarRouteRouteImport } from './routes/$lang/_authenticated/menu-print-tags/bafar/route'
import { Route as LangAuthenticatedMenuPrintTagsAdvaltechRouteRouteImport } from './routes/$lang/_authenticated/menu-print-tags/advaltech/route'
import { Route as LangAuthenticatedHelpBoardTypeRouteRouteImport } from './routes/$lang/_authenticated/help-board/$type/route'
import { Route as LangAuthenticatedDashboardTrackingTypeViewRouteRouteImport } from './routes/$lang/_authenticated/dashboard-tracking/$typeView/route'
import { Route as LangAuthenticatedDashboardMoTypeViewRouteRouteImport } from './routes/$lang/_authenticated/dashboard-mo/$typeView/route'
import { Route as LangAuthenticatedSelectPartsQuantityPartRouteRouteImport } from './routes/$lang/_authenticated/select-parts/$quantity/$part/route'
import { Route as LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRouteImport } from './routes/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/$standardpack/route'
import { Route as LangAuthenticatedMoOptionIdRouteRouteImport } from './routes/$lang/_authenticated/mo/$option/$id/route'
import { Route as LangAuthenticatedHelpBoardTypePartRouteRouteImport } from './routes/$lang/_authenticated/help-board/$type/$part/route'
import { Route as LangAuthenticatedChecklistNameIdHistoryIdRouteRouteImport } from './routes/$lang/_authenticated/checklist/$name/$id/$historyId/route'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRouteRoute = LangRouteRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangAuthenticatedRoute = LangAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => LangRouteRoute,
} as any)
const LangAuthenticatedWorkstationsRouteRoute =
  LangAuthenticatedWorkstationsRouteRouteImport.update({
    id: '/workstations',
    path: '/workstations',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedTagsRouteRoute =
  LangAuthenticatedTagsRouteRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedSelectPartsTrackingRouteRoute =
  LangAuthenticatedSelectPartsTrackingRouteRouteImport.update({
    id: '/select-parts-tracking',
    path: '/select-parts-tracking',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedSelectPartsRouteRoute =
  LangAuthenticatedSelectPartsRouteRouteImport.update({
    id: '/select-parts',
    path: '/select-parts',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedReprintTagsTrackingRouteRoute =
  LangAuthenticatedReprintTagsTrackingRouteRouteImport.update({
    id: '/reprint-tags-tracking',
    path: '/reprint-tags-tracking',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute =
  LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteImport.update({
    id: '/reprint-tags-manufacturing-orders',
    path: '/reprint-tags-manufacturing-orders',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedPrintTagsTrackingRouteRoute =
  LangAuthenticatedPrintTagsTrackingRouteRouteImport.update({
    id: '/print-tags-tracking',
    path: '/print-tags-tracking',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedPrintTagsRouteRoute =
  LangAuthenticatedPrintTagsRouteRouteImport.update({
    id: '/print-tags',
    path: '/print-tags',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedMoRouteRoute =
  LangAuthenticatedMoRouteRouteImport.update({
    id: '/mo',
    path: '/mo',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedMenuPrintTagsRouteRoute =
  LangAuthenticatedMenuPrintTagsRouteRouteImport.update({
    id: '/menu-print-tags',
    path: '/menu-print-tags',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedHelpBoardRouteRoute =
  LangAuthenticatedHelpBoardRouteRouteImport.update({
    id: '/help-board',
    path: '/help-board',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedDashboardTrackingRouteRoute =
  LangAuthenticatedDashboardTrackingRouteRouteImport.update({
    id: '/dashboard-tracking',
    path: '/dashboard-tracking',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedDashboardMoRouteRoute =
  LangAuthenticatedDashboardMoRouteRouteImport.update({
    id: '/dashboard-mo',
    path: '/dashboard-mo',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedDashboardRouteRoute =
  LangAuthenticatedDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedChecklistsManualRouteRoute =
  LangAuthenticatedChecklistsManualRouteRouteImport.update({
    id: '/checklists-manual',
    path: '/checklists-manual',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedChecklistsRouteRoute =
  LangAuthenticatedChecklistsRouteRouteImport.update({
    id: '/checklists',
    path: '/checklists',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)
const LangAuthenticatedTagsViewRouteRoute =
  LangAuthenticatedTagsViewRouteRouteImport.update({
    id: '/$view',
    path: '/$view',
    getParentRoute: () => LangAuthenticatedTagsRouteRoute,
  } as any)
const LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute =
  LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteImport.update({
    id: '/$lot',
    path: '/$lot',
    getParentRoute: () =>
      LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute,
  } as any)
const LangAuthenticatedMoOptionRouteRoute =
  LangAuthenticatedMoOptionRouteRouteImport.update({
    id: '/$option',
    path: '/$option',
    getParentRoute: () => LangAuthenticatedMoRouteRoute,
  } as any)
const LangAuthenticatedMenuPrintTagsDefaultRouteRoute =
  LangAuthenticatedMenuPrintTagsDefaultRouteRouteImport.update({
    id: '/default',
    path: '/default',
    getParentRoute: () => LangAuthenticatedMenuPrintTagsRouteRoute,
  } as any)
const LangAuthenticatedMenuPrintTagsBafarRouteRoute =
  LangAuthenticatedMenuPrintTagsBafarRouteRouteImport.update({
    id: '/bafar',
    path: '/bafar',
    getParentRoute: () => LangAuthenticatedMenuPrintTagsRouteRoute,
  } as any)
const LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute =
  LangAuthenticatedMenuPrintTagsAdvaltechRouteRouteImport.update({
    id: '/advaltech',
    path: '/advaltech',
    getParentRoute: () => LangAuthenticatedMenuPrintTagsRouteRoute,
  } as any)
const LangAuthenticatedHelpBoardTypeRouteRoute =
  LangAuthenticatedHelpBoardTypeRouteRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () => LangAuthenticatedHelpBoardRouteRoute,
  } as any)
const LangAuthenticatedDashboardTrackingTypeViewRouteRoute =
  LangAuthenticatedDashboardTrackingTypeViewRouteRouteImport.update({
    id: '/$typeView',
    path: '/$typeView',
    getParentRoute: () => LangAuthenticatedDashboardTrackingRouteRoute,
  } as any)
const LangAuthenticatedDashboardMoTypeViewRouteRoute =
  LangAuthenticatedDashboardMoTypeViewRouteRouteImport.update({
    id: '/$typeView',
    path: '/$typeView',
    getParentRoute: () => LangAuthenticatedDashboardMoRouteRoute,
  } as any)
const LangAuthenticatedSelectPartsQuantityPartRouteRoute =
  LangAuthenticatedSelectPartsQuantityPartRouteRouteImport.update({
    id: '/$quantity/$part',
    path: '/$quantity/$part',
    getParentRoute: () => LangAuthenticatedSelectPartsRouteRoute,
  } as any)
const LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute =
  LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRouteImport.update(
    {
      id: '/$standardpack',
      path: '/$standardpack',
      getParentRoute: () =>
        LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute,
    } as any,
  )
const LangAuthenticatedMoOptionIdRouteRoute =
  LangAuthenticatedMoOptionIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => LangAuthenticatedMoOptionRouteRoute,
  } as any)
const LangAuthenticatedHelpBoardTypePartRouteRoute =
  LangAuthenticatedHelpBoardTypePartRouteRouteImport.update({
    id: '/$part',
    path: '/$part',
    getParentRoute: () => LangAuthenticatedHelpBoardTypeRouteRoute,
  } as any)
const LangAuthenticatedChecklistNameIdHistoryIdRouteRoute =
  LangAuthenticatedChecklistNameIdHistoryIdRouteRouteImport.update({
    id: '/checklist/$name/$id/$historyId',
    path: '/checklist/$name/$id/$historyId',
    getParentRoute: () => LangAuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangAuthenticatedRouteWithChildren
  '/$': typeof SplatRoute
  '/$lang/checklists': typeof LangAuthenticatedChecklistsRouteRoute
  '/$lang/checklists-manual': typeof LangAuthenticatedChecklistsManualRouteRoute
  '/$lang/dashboard': typeof LangAuthenticatedDashboardRouteRoute
  '/$lang/dashboard-mo': typeof LangAuthenticatedDashboardMoRouteRouteWithChildren
  '/$lang/dashboard-tracking': typeof LangAuthenticatedDashboardTrackingRouteRouteWithChildren
  '/$lang/help-board': typeof LangAuthenticatedHelpBoardRouteRouteWithChildren
  '/$lang/menu-print-tags': typeof LangAuthenticatedMenuPrintTagsRouteRouteWithChildren
  '/$lang/mo': typeof LangAuthenticatedMoRouteRouteWithChildren
  '/$lang/print-tags': typeof LangAuthenticatedPrintTagsRouteRoute
  '/$lang/print-tags-tracking': typeof LangAuthenticatedPrintTagsTrackingRouteRoute
  '/$lang/reprint-tags-manufacturing-orders': typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren
  '/$lang/reprint-tags-tracking': typeof LangAuthenticatedReprintTagsTrackingRouteRoute
  '/$lang/select-parts': typeof LangAuthenticatedSelectPartsRouteRouteWithChildren
  '/$lang/select-parts-tracking': typeof LangAuthenticatedSelectPartsTrackingRouteRoute
  '/$lang/tags': typeof LangAuthenticatedTagsRouteRouteWithChildren
  '/$lang/workstations': typeof LangAuthenticatedWorkstationsRouteRoute
  '/$lang/dashboard-mo/$typeView': typeof LangAuthenticatedDashboardMoTypeViewRouteRoute
  '/$lang/dashboard-tracking/$typeView': typeof LangAuthenticatedDashboardTrackingTypeViewRouteRoute
  '/$lang/help-board/$type': typeof LangAuthenticatedHelpBoardTypeRouteRouteWithChildren
  '/$lang/menu-print-tags/advaltech': typeof LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute
  '/$lang/menu-print-tags/bafar': typeof LangAuthenticatedMenuPrintTagsBafarRouteRoute
  '/$lang/menu-print-tags/default': typeof LangAuthenticatedMenuPrintTagsDefaultRouteRoute
  '/$lang/mo/$option': typeof LangAuthenticatedMoOptionRouteRouteWithChildren
  '/$lang/reprint-tags-manufacturing-orders/$lot': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren
  '/$lang/tags/$view': typeof LangAuthenticatedTagsViewRouteRoute
  '/$lang/help-board/$type/$part': typeof LangAuthenticatedHelpBoardTypePartRouteRoute
  '/$lang/mo/$option/$id': typeof LangAuthenticatedMoOptionIdRouteRoute
  '/$lang/reprint-tags-manufacturing-orders/$lot/$standardpack': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute
  '/$lang/select-parts/$quantity/$part': typeof LangAuthenticatedSelectPartsQuantityPartRouteRoute
  '/$lang/checklist/$name/$id/$historyId': typeof LangAuthenticatedChecklistNameIdHistoryIdRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang': typeof LangAuthenticatedRouteWithChildren
  '/$': typeof SplatRoute
  '/$lang/checklists': typeof LangAuthenticatedChecklistsRouteRoute
  '/$lang/checklists-manual': typeof LangAuthenticatedChecklistsManualRouteRoute
  '/$lang/dashboard': typeof LangAuthenticatedDashboardRouteRoute
  '/$lang/dashboard-mo': typeof LangAuthenticatedDashboardMoRouteRouteWithChildren
  '/$lang/dashboard-tracking': typeof LangAuthenticatedDashboardTrackingRouteRouteWithChildren
  '/$lang/help-board': typeof LangAuthenticatedHelpBoardRouteRouteWithChildren
  '/$lang/menu-print-tags': typeof LangAuthenticatedMenuPrintTagsRouteRouteWithChildren
  '/$lang/mo': typeof LangAuthenticatedMoRouteRouteWithChildren
  '/$lang/print-tags': typeof LangAuthenticatedPrintTagsRouteRoute
  '/$lang/print-tags-tracking': typeof LangAuthenticatedPrintTagsTrackingRouteRoute
  '/$lang/reprint-tags-manufacturing-orders': typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren
  '/$lang/reprint-tags-tracking': typeof LangAuthenticatedReprintTagsTrackingRouteRoute
  '/$lang/select-parts': typeof LangAuthenticatedSelectPartsRouteRouteWithChildren
  '/$lang/select-parts-tracking': typeof LangAuthenticatedSelectPartsTrackingRouteRoute
  '/$lang/tags': typeof LangAuthenticatedTagsRouteRouteWithChildren
  '/$lang/workstations': typeof LangAuthenticatedWorkstationsRouteRoute
  '/$lang/dashboard-mo/$typeView': typeof LangAuthenticatedDashboardMoTypeViewRouteRoute
  '/$lang/dashboard-tracking/$typeView': typeof LangAuthenticatedDashboardTrackingTypeViewRouteRoute
  '/$lang/help-board/$type': typeof LangAuthenticatedHelpBoardTypeRouteRouteWithChildren
  '/$lang/menu-print-tags/advaltech': typeof LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute
  '/$lang/menu-print-tags/bafar': typeof LangAuthenticatedMenuPrintTagsBafarRouteRoute
  '/$lang/menu-print-tags/default': typeof LangAuthenticatedMenuPrintTagsDefaultRouteRoute
  '/$lang/mo/$option': typeof LangAuthenticatedMoOptionRouteRouteWithChildren
  '/$lang/reprint-tags-manufacturing-orders/$lot': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren
  '/$lang/tags/$view': typeof LangAuthenticatedTagsViewRouteRoute
  '/$lang/help-board/$type/$part': typeof LangAuthenticatedHelpBoardTypePartRouteRoute
  '/$lang/mo/$option/$id': typeof LangAuthenticatedMoOptionIdRouteRoute
  '/$lang/reprint-tags-manufacturing-orders/$lot/$standardpack': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute
  '/$lang/select-parts/$quantity/$part': typeof LangAuthenticatedSelectPartsQuantityPartRouteRoute
  '/$lang/checklist/$name/$id/$historyId': typeof LangAuthenticatedChecklistNameIdHistoryIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/$lang/_authenticated': typeof LangAuthenticatedRouteWithChildren
  '/$lang/_authenticated/checklists': typeof LangAuthenticatedChecklistsRouteRoute
  '/$lang/_authenticated/checklists-manual': typeof LangAuthenticatedChecklistsManualRouteRoute
  '/$lang/_authenticated/dashboard': typeof LangAuthenticatedDashboardRouteRoute
  '/$lang/_authenticated/dashboard-mo': typeof LangAuthenticatedDashboardMoRouteRouteWithChildren
  '/$lang/_authenticated/dashboard-tracking': typeof LangAuthenticatedDashboardTrackingRouteRouteWithChildren
  '/$lang/_authenticated/help-board': typeof LangAuthenticatedHelpBoardRouteRouteWithChildren
  '/$lang/_authenticated/menu-print-tags': typeof LangAuthenticatedMenuPrintTagsRouteRouteWithChildren
  '/$lang/_authenticated/mo': typeof LangAuthenticatedMoRouteRouteWithChildren
  '/$lang/_authenticated/print-tags': typeof LangAuthenticatedPrintTagsRouteRoute
  '/$lang/_authenticated/print-tags-tracking': typeof LangAuthenticatedPrintTagsTrackingRouteRoute
  '/$lang/_authenticated/reprint-tags-manufacturing-orders': typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren
  '/$lang/_authenticated/reprint-tags-tracking': typeof LangAuthenticatedReprintTagsTrackingRouteRoute
  '/$lang/_authenticated/select-parts': typeof LangAuthenticatedSelectPartsRouteRouteWithChildren
  '/$lang/_authenticated/select-parts-tracking': typeof LangAuthenticatedSelectPartsTrackingRouteRoute
  '/$lang/_authenticated/tags': typeof LangAuthenticatedTagsRouteRouteWithChildren
  '/$lang/_authenticated/workstations': typeof LangAuthenticatedWorkstationsRouteRoute
  '/$lang/_authenticated/dashboard-mo/$typeView': typeof LangAuthenticatedDashboardMoTypeViewRouteRoute
  '/$lang/_authenticated/dashboard-tracking/$typeView': typeof LangAuthenticatedDashboardTrackingTypeViewRouteRoute
  '/$lang/_authenticated/help-board/$type': typeof LangAuthenticatedHelpBoardTypeRouteRouteWithChildren
  '/$lang/_authenticated/menu-print-tags/advaltech': typeof LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute
  '/$lang/_authenticated/menu-print-tags/bafar': typeof LangAuthenticatedMenuPrintTagsBafarRouteRoute
  '/$lang/_authenticated/menu-print-tags/default': typeof LangAuthenticatedMenuPrintTagsDefaultRouteRoute
  '/$lang/_authenticated/mo/$option': typeof LangAuthenticatedMoOptionRouteRouteWithChildren
  '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren
  '/$lang/_authenticated/tags/$view': typeof LangAuthenticatedTagsViewRouteRoute
  '/$lang/_authenticated/help-board/$type/$part': typeof LangAuthenticatedHelpBoardTypePartRouteRoute
  '/$lang/_authenticated/mo/$option/$id': typeof LangAuthenticatedMoOptionIdRouteRoute
  '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/$standardpack': typeof LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute
  '/$lang/_authenticated/select-parts/$quantity/$part': typeof LangAuthenticatedSelectPartsQuantityPartRouteRoute
  '/$lang/_authenticated/checklist/$name/$id/$historyId': typeof LangAuthenticatedChecklistNameIdHistoryIdRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/$'
    | '/$lang/checklists'
    | '/$lang/checklists-manual'
    | '/$lang/dashboard'
    | '/$lang/dashboard-mo'
    | '/$lang/dashboard-tracking'
    | '/$lang/help-board'
    | '/$lang/menu-print-tags'
    | '/$lang/mo'
    | '/$lang/print-tags'
    | '/$lang/print-tags-tracking'
    | '/$lang/reprint-tags-manufacturing-orders'
    | '/$lang/reprint-tags-tracking'
    | '/$lang/select-parts'
    | '/$lang/select-parts-tracking'
    | '/$lang/tags'
    | '/$lang/workstations'
    | '/$lang/dashboard-mo/$typeView'
    | '/$lang/dashboard-tracking/$typeView'
    | '/$lang/help-board/$type'
    | '/$lang/menu-print-tags/advaltech'
    | '/$lang/menu-print-tags/bafar'
    | '/$lang/menu-print-tags/default'
    | '/$lang/mo/$option'
    | '/$lang/reprint-tags-manufacturing-orders/$lot'
    | '/$lang/tags/$view'
    | '/$lang/help-board/$type/$part'
    | '/$lang/mo/$option/$id'
    | '/$lang/reprint-tags-manufacturing-orders/$lot/$standardpack'
    | '/$lang/select-parts/$quantity/$part'
    | '/$lang/checklist/$name/$id/$historyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang'
    | '/$'
    | '/$lang/checklists'
    | '/$lang/checklists-manual'
    | '/$lang/dashboard'
    | '/$lang/dashboard-mo'
    | '/$lang/dashboard-tracking'
    | '/$lang/help-board'
    | '/$lang/menu-print-tags'
    | '/$lang/mo'
    | '/$lang/print-tags'
    | '/$lang/print-tags-tracking'
    | '/$lang/reprint-tags-manufacturing-orders'
    | '/$lang/reprint-tags-tracking'
    | '/$lang/select-parts'
    | '/$lang/select-parts-tracking'
    | '/$lang/tags'
    | '/$lang/workstations'
    | '/$lang/dashboard-mo/$typeView'
    | '/$lang/dashboard-tracking/$typeView'
    | '/$lang/help-board/$type'
    | '/$lang/menu-print-tags/advaltech'
    | '/$lang/menu-print-tags/bafar'
    | '/$lang/menu-print-tags/default'
    | '/$lang/mo/$option'
    | '/$lang/reprint-tags-manufacturing-orders/$lot'
    | '/$lang/tags/$view'
    | '/$lang/help-board/$type/$part'
    | '/$lang/mo/$option/$id'
    | '/$lang/reprint-tags-manufacturing-orders/$lot/$standardpack'
    | '/$lang/select-parts/$quantity/$part'
    | '/$lang/checklist/$name/$id/$historyId'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/$'
    | '/$lang/_authenticated'
    | '/$lang/_authenticated/checklists'
    | '/$lang/_authenticated/checklists-manual'
    | '/$lang/_authenticated/dashboard'
    | '/$lang/_authenticated/dashboard-mo'
    | '/$lang/_authenticated/dashboard-tracking'
    | '/$lang/_authenticated/help-board'
    | '/$lang/_authenticated/menu-print-tags'
    | '/$lang/_authenticated/mo'
    | '/$lang/_authenticated/print-tags'
    | '/$lang/_authenticated/print-tags-tracking'
    | '/$lang/_authenticated/reprint-tags-manufacturing-orders'
    | '/$lang/_authenticated/reprint-tags-tracking'
    | '/$lang/_authenticated/select-parts'
    | '/$lang/_authenticated/select-parts-tracking'
    | '/$lang/_authenticated/tags'
    | '/$lang/_authenticated/workstations'
    | '/$lang/_authenticated/dashboard-mo/$typeView'
    | '/$lang/_authenticated/dashboard-tracking/$typeView'
    | '/$lang/_authenticated/help-board/$type'
    | '/$lang/_authenticated/menu-print-tags/advaltech'
    | '/$lang/_authenticated/menu-print-tags/bafar'
    | '/$lang/_authenticated/menu-print-tags/default'
    | '/$lang/_authenticated/mo/$option'
    | '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot'
    | '/$lang/_authenticated/tags/$view'
    | '/$lang/_authenticated/help-board/$type/$part'
    | '/$lang/_authenticated/mo/$option/$id'
    | '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/$standardpack'
    | '/$lang/_authenticated/select-parts/$quantity/$part'
    | '/$lang/_authenticated/checklist/$name/$id/$historyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRouteRoute: typeof LangRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/_authenticated': {
      id: '/$lang/_authenticated'
      path: ''
      fullPath: '/$lang'
      preLoaderRoute: typeof LangAuthenticatedRouteImport
      parentRoute: typeof LangRouteRoute
    }
    '/$lang/_authenticated/workstations': {
      id: '/$lang/_authenticated/workstations'
      path: '/workstations'
      fullPath: '/$lang/workstations'
      preLoaderRoute: typeof LangAuthenticatedWorkstationsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/tags': {
      id: '/$lang/_authenticated/tags'
      path: '/tags'
      fullPath: '/$lang/tags'
      preLoaderRoute: typeof LangAuthenticatedTagsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/select-parts-tracking': {
      id: '/$lang/_authenticated/select-parts-tracking'
      path: '/select-parts-tracking'
      fullPath: '/$lang/select-parts-tracking'
      preLoaderRoute: typeof LangAuthenticatedSelectPartsTrackingRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/select-parts': {
      id: '/$lang/_authenticated/select-parts'
      path: '/select-parts'
      fullPath: '/$lang/select-parts'
      preLoaderRoute: typeof LangAuthenticatedSelectPartsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/reprint-tags-tracking': {
      id: '/$lang/_authenticated/reprint-tags-tracking'
      path: '/reprint-tags-tracking'
      fullPath: '/$lang/reprint-tags-tracking'
      preLoaderRoute: typeof LangAuthenticatedReprintTagsTrackingRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/reprint-tags-manufacturing-orders': {
      id: '/$lang/_authenticated/reprint-tags-manufacturing-orders'
      path: '/reprint-tags-manufacturing-orders'
      fullPath: '/$lang/reprint-tags-manufacturing-orders'
      preLoaderRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/print-tags-tracking': {
      id: '/$lang/_authenticated/print-tags-tracking'
      path: '/print-tags-tracking'
      fullPath: '/$lang/print-tags-tracking'
      preLoaderRoute: typeof LangAuthenticatedPrintTagsTrackingRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/print-tags': {
      id: '/$lang/_authenticated/print-tags'
      path: '/print-tags'
      fullPath: '/$lang/print-tags'
      preLoaderRoute: typeof LangAuthenticatedPrintTagsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/mo': {
      id: '/$lang/_authenticated/mo'
      path: '/mo'
      fullPath: '/$lang/mo'
      preLoaderRoute: typeof LangAuthenticatedMoRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/menu-print-tags': {
      id: '/$lang/_authenticated/menu-print-tags'
      path: '/menu-print-tags'
      fullPath: '/$lang/menu-print-tags'
      preLoaderRoute: typeof LangAuthenticatedMenuPrintTagsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/help-board': {
      id: '/$lang/_authenticated/help-board'
      path: '/help-board'
      fullPath: '/$lang/help-board'
      preLoaderRoute: typeof LangAuthenticatedHelpBoardRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/dashboard-tracking': {
      id: '/$lang/_authenticated/dashboard-tracking'
      path: '/dashboard-tracking'
      fullPath: '/$lang/dashboard-tracking'
      preLoaderRoute: typeof LangAuthenticatedDashboardTrackingRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/dashboard-mo': {
      id: '/$lang/_authenticated/dashboard-mo'
      path: '/dashboard-mo'
      fullPath: '/$lang/dashboard-mo'
      preLoaderRoute: typeof LangAuthenticatedDashboardMoRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/dashboard': {
      id: '/$lang/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/$lang/dashboard'
      preLoaderRoute: typeof LangAuthenticatedDashboardRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/checklists-manual': {
      id: '/$lang/_authenticated/checklists-manual'
      path: '/checklists-manual'
      fullPath: '/$lang/checklists-manual'
      preLoaderRoute: typeof LangAuthenticatedChecklistsManualRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/checklists': {
      id: '/$lang/_authenticated/checklists'
      path: '/checklists'
      fullPath: '/$lang/checklists'
      preLoaderRoute: typeof LangAuthenticatedChecklistsRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
    '/$lang/_authenticated/tags/$view': {
      id: '/$lang/_authenticated/tags/$view'
      path: '/$view'
      fullPath: '/$lang/tags/$view'
      preLoaderRoute: typeof LangAuthenticatedTagsViewRouteRouteImport
      parentRoute: typeof LangAuthenticatedTagsRouteRoute
    }
    '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot': {
      id: '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot'
      path: '/$lot'
      fullPath: '/$lang/reprint-tags-manufacturing-orders/$lot'
      preLoaderRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteImport
      parentRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute
    }
    '/$lang/_authenticated/mo/$option': {
      id: '/$lang/_authenticated/mo/$option'
      path: '/$option'
      fullPath: '/$lang/mo/$option'
      preLoaderRoute: typeof LangAuthenticatedMoOptionRouteRouteImport
      parentRoute: typeof LangAuthenticatedMoRouteRoute
    }
    '/$lang/_authenticated/menu-print-tags/default': {
      id: '/$lang/_authenticated/menu-print-tags/default'
      path: '/default'
      fullPath: '/$lang/menu-print-tags/default'
      preLoaderRoute: typeof LangAuthenticatedMenuPrintTagsDefaultRouteRouteImport
      parentRoute: typeof LangAuthenticatedMenuPrintTagsRouteRoute
    }
    '/$lang/_authenticated/menu-print-tags/bafar': {
      id: '/$lang/_authenticated/menu-print-tags/bafar'
      path: '/bafar'
      fullPath: '/$lang/menu-print-tags/bafar'
      preLoaderRoute: typeof LangAuthenticatedMenuPrintTagsBafarRouteRouteImport
      parentRoute: typeof LangAuthenticatedMenuPrintTagsRouteRoute
    }
    '/$lang/_authenticated/menu-print-tags/advaltech': {
      id: '/$lang/_authenticated/menu-print-tags/advaltech'
      path: '/advaltech'
      fullPath: '/$lang/menu-print-tags/advaltech'
      preLoaderRoute: typeof LangAuthenticatedMenuPrintTagsAdvaltechRouteRouteImport
      parentRoute: typeof LangAuthenticatedMenuPrintTagsRouteRoute
    }
    '/$lang/_authenticated/help-board/$type': {
      id: '/$lang/_authenticated/help-board/$type'
      path: '/$type'
      fullPath: '/$lang/help-board/$type'
      preLoaderRoute: typeof LangAuthenticatedHelpBoardTypeRouteRouteImport
      parentRoute: typeof LangAuthenticatedHelpBoardRouteRoute
    }
    '/$lang/_authenticated/dashboard-tracking/$typeView': {
      id: '/$lang/_authenticated/dashboard-tracking/$typeView'
      path: '/$typeView'
      fullPath: '/$lang/dashboard-tracking/$typeView'
      preLoaderRoute: typeof LangAuthenticatedDashboardTrackingTypeViewRouteRouteImport
      parentRoute: typeof LangAuthenticatedDashboardTrackingRouteRoute
    }
    '/$lang/_authenticated/dashboard-mo/$typeView': {
      id: '/$lang/_authenticated/dashboard-mo/$typeView'
      path: '/$typeView'
      fullPath: '/$lang/dashboard-mo/$typeView'
      preLoaderRoute: typeof LangAuthenticatedDashboardMoTypeViewRouteRouteImport
      parentRoute: typeof LangAuthenticatedDashboardMoRouteRoute
    }
    '/$lang/_authenticated/select-parts/$quantity/$part': {
      id: '/$lang/_authenticated/select-parts/$quantity/$part'
      path: '/$quantity/$part'
      fullPath: '/$lang/select-parts/$quantity/$part'
      preLoaderRoute: typeof LangAuthenticatedSelectPartsQuantityPartRouteRouteImport
      parentRoute: typeof LangAuthenticatedSelectPartsRouteRoute
    }
    '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/$standardpack': {
      id: '/$lang/_authenticated/reprint-tags-manufacturing-orders/$lot/$standardpack'
      path: '/$standardpack'
      fullPath: '/$lang/reprint-tags-manufacturing-orders/$lot/$standardpack'
      preLoaderRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRouteImport
      parentRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute
    }
    '/$lang/_authenticated/mo/$option/$id': {
      id: '/$lang/_authenticated/mo/$option/$id'
      path: '/$id'
      fullPath: '/$lang/mo/$option/$id'
      preLoaderRoute: typeof LangAuthenticatedMoOptionIdRouteRouteImport
      parentRoute: typeof LangAuthenticatedMoOptionRouteRoute
    }
    '/$lang/_authenticated/help-board/$type/$part': {
      id: '/$lang/_authenticated/help-board/$type/$part'
      path: '/$part'
      fullPath: '/$lang/help-board/$type/$part'
      preLoaderRoute: typeof LangAuthenticatedHelpBoardTypePartRouteRouteImport
      parentRoute: typeof LangAuthenticatedHelpBoardTypeRouteRoute
    }
    '/$lang/_authenticated/checklist/$name/$id/$historyId': {
      id: '/$lang/_authenticated/checklist/$name/$id/$historyId'
      path: '/checklist/$name/$id/$historyId'
      fullPath: '/$lang/checklist/$name/$id/$historyId'
      preLoaderRoute: typeof LangAuthenticatedChecklistNameIdHistoryIdRouteRouteImport
      parentRoute: typeof LangAuthenticatedRoute
    }
  }
}

interface LangAuthenticatedDashboardMoRouteRouteChildren {
  LangAuthenticatedDashboardMoTypeViewRouteRoute: typeof LangAuthenticatedDashboardMoTypeViewRouteRoute
}

const LangAuthenticatedDashboardMoRouteRouteChildren: LangAuthenticatedDashboardMoRouteRouteChildren =
  {
    LangAuthenticatedDashboardMoTypeViewRouteRoute:
      LangAuthenticatedDashboardMoTypeViewRouteRoute,
  }

const LangAuthenticatedDashboardMoRouteRouteWithChildren =
  LangAuthenticatedDashboardMoRouteRoute._addFileChildren(
    LangAuthenticatedDashboardMoRouteRouteChildren,
  )

interface LangAuthenticatedDashboardTrackingRouteRouteChildren {
  LangAuthenticatedDashboardTrackingTypeViewRouteRoute: typeof LangAuthenticatedDashboardTrackingTypeViewRouteRoute
}

const LangAuthenticatedDashboardTrackingRouteRouteChildren: LangAuthenticatedDashboardTrackingRouteRouteChildren =
  {
    LangAuthenticatedDashboardTrackingTypeViewRouteRoute:
      LangAuthenticatedDashboardTrackingTypeViewRouteRoute,
  }

const LangAuthenticatedDashboardTrackingRouteRouteWithChildren =
  LangAuthenticatedDashboardTrackingRouteRoute._addFileChildren(
    LangAuthenticatedDashboardTrackingRouteRouteChildren,
  )

interface LangAuthenticatedHelpBoardTypeRouteRouteChildren {
  LangAuthenticatedHelpBoardTypePartRouteRoute: typeof LangAuthenticatedHelpBoardTypePartRouteRoute
}

const LangAuthenticatedHelpBoardTypeRouteRouteChildren: LangAuthenticatedHelpBoardTypeRouteRouteChildren =
  {
    LangAuthenticatedHelpBoardTypePartRouteRoute:
      LangAuthenticatedHelpBoardTypePartRouteRoute,
  }

const LangAuthenticatedHelpBoardTypeRouteRouteWithChildren =
  LangAuthenticatedHelpBoardTypeRouteRoute._addFileChildren(
    LangAuthenticatedHelpBoardTypeRouteRouteChildren,
  )

interface LangAuthenticatedHelpBoardRouteRouteChildren {
  LangAuthenticatedHelpBoardTypeRouteRoute: typeof LangAuthenticatedHelpBoardTypeRouteRouteWithChildren
}

const LangAuthenticatedHelpBoardRouteRouteChildren: LangAuthenticatedHelpBoardRouteRouteChildren =
  {
    LangAuthenticatedHelpBoardTypeRouteRoute:
      LangAuthenticatedHelpBoardTypeRouteRouteWithChildren,
  }

const LangAuthenticatedHelpBoardRouteRouteWithChildren =
  LangAuthenticatedHelpBoardRouteRoute._addFileChildren(
    LangAuthenticatedHelpBoardRouteRouteChildren,
  )

interface LangAuthenticatedMenuPrintTagsRouteRouteChildren {
  LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute: typeof LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute
  LangAuthenticatedMenuPrintTagsBafarRouteRoute: typeof LangAuthenticatedMenuPrintTagsBafarRouteRoute
  LangAuthenticatedMenuPrintTagsDefaultRouteRoute: typeof LangAuthenticatedMenuPrintTagsDefaultRouteRoute
}

const LangAuthenticatedMenuPrintTagsRouteRouteChildren: LangAuthenticatedMenuPrintTagsRouteRouteChildren =
  {
    LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute:
      LangAuthenticatedMenuPrintTagsAdvaltechRouteRoute,
    LangAuthenticatedMenuPrintTagsBafarRouteRoute:
      LangAuthenticatedMenuPrintTagsBafarRouteRoute,
    LangAuthenticatedMenuPrintTagsDefaultRouteRoute:
      LangAuthenticatedMenuPrintTagsDefaultRouteRoute,
  }

const LangAuthenticatedMenuPrintTagsRouteRouteWithChildren =
  LangAuthenticatedMenuPrintTagsRouteRoute._addFileChildren(
    LangAuthenticatedMenuPrintTagsRouteRouteChildren,
  )

interface LangAuthenticatedMoOptionRouteRouteChildren {
  LangAuthenticatedMoOptionIdRouteRoute: typeof LangAuthenticatedMoOptionIdRouteRoute
}

const LangAuthenticatedMoOptionRouteRouteChildren: LangAuthenticatedMoOptionRouteRouteChildren =
  {
    LangAuthenticatedMoOptionIdRouteRoute:
      LangAuthenticatedMoOptionIdRouteRoute,
  }

const LangAuthenticatedMoOptionRouteRouteWithChildren =
  LangAuthenticatedMoOptionRouteRoute._addFileChildren(
    LangAuthenticatedMoOptionRouteRouteChildren,
  )

interface LangAuthenticatedMoRouteRouteChildren {
  LangAuthenticatedMoOptionRouteRoute: typeof LangAuthenticatedMoOptionRouteRouteWithChildren
}

const LangAuthenticatedMoRouteRouteChildren: LangAuthenticatedMoRouteRouteChildren =
  {
    LangAuthenticatedMoOptionRouteRoute:
      LangAuthenticatedMoOptionRouteRouteWithChildren,
  }

const LangAuthenticatedMoRouteRouteWithChildren =
  LangAuthenticatedMoRouteRoute._addFileChildren(
    LangAuthenticatedMoRouteRouteChildren,
  )

interface LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteChildren {
  LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute
}

const LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteChildren: LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteChildren =
  {
    LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute:
      LangAuthenticatedReprintTagsManufacturingOrdersLotStandardpackRouteRoute,
  }

const LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren =
  LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute._addFileChildren(
    LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteChildren,
  )

interface LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteChildren {
  LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren
}

const LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteChildren: LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteChildren =
  {
    LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRoute:
      LangAuthenticatedReprintTagsManufacturingOrdersLotRouteRouteWithChildren,
  }

const LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren =
  LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute._addFileChildren(
    LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteChildren,
  )

interface LangAuthenticatedSelectPartsRouteRouteChildren {
  LangAuthenticatedSelectPartsQuantityPartRouteRoute: typeof LangAuthenticatedSelectPartsQuantityPartRouteRoute
}

const LangAuthenticatedSelectPartsRouteRouteChildren: LangAuthenticatedSelectPartsRouteRouteChildren =
  {
    LangAuthenticatedSelectPartsQuantityPartRouteRoute:
      LangAuthenticatedSelectPartsQuantityPartRouteRoute,
  }

const LangAuthenticatedSelectPartsRouteRouteWithChildren =
  LangAuthenticatedSelectPartsRouteRoute._addFileChildren(
    LangAuthenticatedSelectPartsRouteRouteChildren,
  )

interface LangAuthenticatedTagsRouteRouteChildren {
  LangAuthenticatedTagsViewRouteRoute: typeof LangAuthenticatedTagsViewRouteRoute
}

const LangAuthenticatedTagsRouteRouteChildren: LangAuthenticatedTagsRouteRouteChildren =
  {
    LangAuthenticatedTagsViewRouteRoute: LangAuthenticatedTagsViewRouteRoute,
  }

const LangAuthenticatedTagsRouteRouteWithChildren =
  LangAuthenticatedTagsRouteRoute._addFileChildren(
    LangAuthenticatedTagsRouteRouteChildren,
  )

interface LangAuthenticatedRouteChildren {
  LangAuthenticatedChecklistsRouteRoute: typeof LangAuthenticatedChecklistsRouteRoute
  LangAuthenticatedChecklistsManualRouteRoute: typeof LangAuthenticatedChecklistsManualRouteRoute
  LangAuthenticatedDashboardRouteRoute: typeof LangAuthenticatedDashboardRouteRoute
  LangAuthenticatedDashboardMoRouteRoute: typeof LangAuthenticatedDashboardMoRouteRouteWithChildren
  LangAuthenticatedDashboardTrackingRouteRoute: typeof LangAuthenticatedDashboardTrackingRouteRouteWithChildren
  LangAuthenticatedHelpBoardRouteRoute: typeof LangAuthenticatedHelpBoardRouteRouteWithChildren
  LangAuthenticatedMenuPrintTagsRouteRoute: typeof LangAuthenticatedMenuPrintTagsRouteRouteWithChildren
  LangAuthenticatedMoRouteRoute: typeof LangAuthenticatedMoRouteRouteWithChildren
  LangAuthenticatedPrintTagsRouteRoute: typeof LangAuthenticatedPrintTagsRouteRoute
  LangAuthenticatedPrintTagsTrackingRouteRoute: typeof LangAuthenticatedPrintTagsTrackingRouteRoute
  LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute: typeof LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren
  LangAuthenticatedReprintTagsTrackingRouteRoute: typeof LangAuthenticatedReprintTagsTrackingRouteRoute
  LangAuthenticatedSelectPartsRouteRoute: typeof LangAuthenticatedSelectPartsRouteRouteWithChildren
  LangAuthenticatedSelectPartsTrackingRouteRoute: typeof LangAuthenticatedSelectPartsTrackingRouteRoute
  LangAuthenticatedTagsRouteRoute: typeof LangAuthenticatedTagsRouteRouteWithChildren
  LangAuthenticatedWorkstationsRouteRoute: typeof LangAuthenticatedWorkstationsRouteRoute
  LangAuthenticatedChecklistNameIdHistoryIdRouteRoute: typeof LangAuthenticatedChecklistNameIdHistoryIdRouteRoute
}

const LangAuthenticatedRouteChildren: LangAuthenticatedRouteChildren = {
  LangAuthenticatedChecklistsRouteRoute: LangAuthenticatedChecklistsRouteRoute,
  LangAuthenticatedChecklistsManualRouteRoute:
    LangAuthenticatedChecklistsManualRouteRoute,
  LangAuthenticatedDashboardRouteRoute: LangAuthenticatedDashboardRouteRoute,
  LangAuthenticatedDashboardMoRouteRoute:
    LangAuthenticatedDashboardMoRouteRouteWithChildren,
  LangAuthenticatedDashboardTrackingRouteRoute:
    LangAuthenticatedDashboardTrackingRouteRouteWithChildren,
  LangAuthenticatedHelpBoardRouteRoute:
    LangAuthenticatedHelpBoardRouteRouteWithChildren,
  LangAuthenticatedMenuPrintTagsRouteRoute:
    LangAuthenticatedMenuPrintTagsRouteRouteWithChildren,
  LangAuthenticatedMoRouteRoute: LangAuthenticatedMoRouteRouteWithChildren,
  LangAuthenticatedPrintTagsRouteRoute: LangAuthenticatedPrintTagsRouteRoute,
  LangAuthenticatedPrintTagsTrackingRouteRoute:
    LangAuthenticatedPrintTagsTrackingRouteRoute,
  LangAuthenticatedReprintTagsManufacturingOrdersRouteRoute:
    LangAuthenticatedReprintTagsManufacturingOrdersRouteRouteWithChildren,
  LangAuthenticatedReprintTagsTrackingRouteRoute:
    LangAuthenticatedReprintTagsTrackingRouteRoute,
  LangAuthenticatedSelectPartsRouteRoute:
    LangAuthenticatedSelectPartsRouteRouteWithChildren,
  LangAuthenticatedSelectPartsTrackingRouteRoute:
    LangAuthenticatedSelectPartsTrackingRouteRoute,
  LangAuthenticatedTagsRouteRoute: LangAuthenticatedTagsRouteRouteWithChildren,
  LangAuthenticatedWorkstationsRouteRoute:
    LangAuthenticatedWorkstationsRouteRoute,
  LangAuthenticatedChecklistNameIdHistoryIdRouteRoute:
    LangAuthenticatedChecklistNameIdHistoryIdRouteRoute,
}

const LangAuthenticatedRouteWithChildren =
  LangAuthenticatedRoute._addFileChildren(LangAuthenticatedRouteChildren)

interface LangRouteRouteChildren {
  LangAuthenticatedRoute: typeof LangAuthenticatedRouteWithChildren
}

const LangRouteRouteChildren: LangRouteRouteChildren = {
  LangAuthenticatedRoute: LangAuthenticatedRouteWithChildren,
}

const LangRouteRouteWithChildren = LangRouteRoute._addFileChildren(
  LangRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRouteRoute: LangRouteRouteWithChildren,
  SplatRoute: SplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
